<template>
    <transition name="fade">
      <div v-if="visible" class="fixed" @click.stop>
        <div class="bg-white popup">
          <div class="popup-header">
            <h1 class="title">Editar página Regalo</h1>
            <img src="@/assets/images/ic_close.svg" class="close_icon" @click="closePopup()" />
          </div>
          
          <div class="popup-body">
            <div class="fields">
              <span for="plans" style="align-self: center;"><b>URL:</b> {{ props.page.url }}</span>
              <label for="title" class="margin-top-20">Título H1:</label>
              <input type="text" class="margin-top-10" id="title" v-model="pageTitle" />
              <div class="margin-top-20">
                <label>Descripción: <span @click="toggleHtmlDescriptionMode" style="cursor: pointer; color: var(--primary-color); font-size: 12px;">(Pincha para ver el HTML)</span></label>
                <QuillEditor 
                  v-if="!isHtmlDescriptionMode"
                  :key="100000000"
                  theme="snow"
                  v-model:content="pageDescription"
                  contentType="html"
                  :toolbar="toolbarOptions"
                  style="height: 200px"
                  class="cp-quill-editor" />
                <textarea
                  v-if="isHtmlDescriptionMode"
                  v-model="pageDescription"
                  style="height: 300px"
                ></textarea>

              </div>
              <label for="title" class="margin-top-20">Título footer:</label>
              <input type="text" class="margin-top-10" id="title" v-model="footerTitle" />
              <div class="margin-top-20">
                <label>Texto footer: <span @click="toggleHtmlFooterDescriptionMode" style="cursor: pointer; color: var(--primary-color); font-size: 12px;">(Pincha para ver el HTML)</span></label>
                <QuillEditor 
                  v-if="!isHtmlFooterDescriptionMode"
                  :key="100000001"
                  theme="snow"
                  v-model:content="footerDescription"
                  contentType="html"
                  :toolbar="toolbarOptions"
                  style="height: 200px"
                  class="cp-quill-editor" />
                <textarea
                  v-if="isHtmlFooterDescriptionMode"
                  v-model="footerDescription"
                  style="height: 300px"
                ></textarea>

              </div>

              <label for="plans" class="margin-top-20">Planes:</label>
              <span class="text-mini">Esta página tiene un total de <b>{{ props.page.num_plans }}</b> planes. Puedes modificarlos a continuación <b>separándolos por coma sin añadir espacios en blanco</b>.</span>
              <input type="text" class="margin-top-10" id="plans" v-model="plans" />
              <label for="title" class="margin-top-20">Título SEO:</label>
              <input type="text" class="margin-top-10" id="seoTitle" v-model="pageSeoTitle" />
              <label for="description" class="margin-top-20">Descripción SEO:</label>
              <input type="text" class="margin-top-10" id="seoDescription" v-model="pageSeoDescription" />
              <label class="checkbox-label margin-top-20">
                <input type="checkbox" name="aceptar" v-model="index" style="width: auto !important;">
                Index
              </label>
            </div>
            <button @click="saveClicked()" class="main_button">Guardar</button>
          </div>
        </div>
      </div>
    </transition>
    <ErrorPopup :errorMessage="error" />
  </template>
  
  <script setup>
  import { ref, watch, defineProps, defineEmits } from 'vue';
  import { useLoadingStore } from "@/stores/loadingStore";
  import { useRouter } from 'vue-router';
  import { refreshToken } from "@/services/authService";
  import ErrorPopup from "@/components/common/ErrorPopup.vue";
  import { QuillEditor } from '@vueup/vue-quill'
  import '@vueup/vue-quill/dist/vue-quill.snow.css'

  const props = defineProps({
    page: Object,
  });
  
  const toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike','link'],
    [{ header: [1, 2, 3, false] }],
    [{ color: [] }, { background: [] }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['clean']
  ];
  const isHtmlDescriptionMode = ref(false)
  const isHtmlFooterDescriptionMode = ref(false)

  const toggleHtmlDescriptionMode = () => {
    isHtmlDescriptionMode.value = !isHtmlDescriptionMode.value
  }

  const toggleHtmlFooterDescriptionMode = () => {
    isHtmlFooterDescriptionMode.value = !isHtmlFooterDescriptionMode.value
  }

  const emit = defineEmits(['closed', 'error', 'saved']);

  const loadingStore = useLoadingStore();
  const router = useRouter();

  const visible = ref(false);
  const error = ref(null);
  const pageTitle = ref("");
  const pageDescription = ref("");
  const footerTitle = ref("");
  const footerDescription = ref("");
  const pageSeoTitle = ref("");
  const pageSeoDescription = ref("");
  const plans = ref("");
  const index = ref(false);

  watch(() => props.page, (newVal) => {
    visible.value = !!newVal;
    if (newVal) {
      pageTitle.value = newVal.title;
      pageDescription.value = newVal.description;
      footerTitle.value = newVal.footer_title;
      footerDescription.value = newVal.footer_description;
      pageSeoTitle.value = newVal.seo_title;
      pageSeoDescription.value = newVal.seo_description;
      plans.value = newVal.plans;
      index.value = newVal.index;
    }
  });
  
  const closePopup = () => {
    visible.value = false;
    emit('closed')
  };
 
  const saveClicked = async () => {
    loadingStore.setLoading(true);
    error.value = null;

    try {
      let response = await updateGiftPageInAPI();

      if (response.status === 401) {
        const refreshed = await refreshToken();
        if (refreshed) {
          response = await updateGiftPageInAPI();
        } else {
          loadingStore.setLoading(false);
          localStorage.removeItem('user_id');
          localStorage.removeItem('token');
          router.push('/');
          return;
        }
      }

      if (!response.ok) {
        emit('error', "Se ha producido un error guardando la página.");
        return;
      }

      const data = await response.json();

      if (data.errors) {
        emit('error', data.message);
      } else {
        emit('saved');
      }
      closePopup();
    } catch (exception) {
      emit('error', exception.message);
    } finally {
      loadingStore.setLoading(false);
    }
  };

  async function updateGiftPageInAPI() {
    return await fetch(process.env.VUE_APP_API_URL + "api/god/pages/set_gift_page_details", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "vgod": process.env.VUE_APP_API_VGOD,
        "cp-token": process.env.VUE_APP_API_CP_TOKEN,
        "Authorization": "Bearer " + localStorage.getItem("token")
      },
      body: JSON.stringify({
        user_id: localStorage.getItem('user_id'),
        url: props.page.url,
        title: pageTitle.value,
        description: pageDescription.value,
        footer_title: footerTitle.value,
        footer_description: footerDescription.value,
        seo_title: pageSeoTitle.value,
        seo_description: pageSeoDescription.value,
        plans: plans.value,
        index: index.value
      })
    });
  }
  </script>
  
  <style scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s ease;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
  
  .fixed {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
  }
  
  .bg-white {
    background-color: white;
    border-radius: var(--radius-lg);
    box-shadow: var(--shadow-lg);
    width: 100%;
    max-width: 600px;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .popup-header {
    padding: var(--spacing-md) var(--spacing-lg);
    border-bottom: 1px solid var(--light-gray);
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .title {
    font-size: 20px;
    font-weight: 700;
    color: var(--text-color-dark);
    margin: 0;
  }

  .close_icon {
    position: absolute;
    right: var(--spacing-md);
    top: 50%;
    transform: translateY(-50%);
    width: 24px;
    height: 24px;
    cursor: pointer;
    opacity: 0.6;
    transition: opacity var(--transition-fast);
  }

  .close_icon:hover {
    opacity: 1;
  }

  .popup-body {
    padding: var(--spacing-lg);
    overflow-y: auto;
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: var(--spacing-md);
  }

  .fields {
    display: flex;
    flex-direction: column;
  }

  .text-mini{
    color: var(--text-color-light);
    font-size: 12px;
    margin-top: 0px;
    margin-bottom: 0px;
  }

  .margin-top-10{
    margin-top: 10px;
  }

  .margin-top-20{
    margin-top: 20px;
  }
  
  .checkbox-label {
    display: inline-flex;
    align-items: center;
    gap: 8px;
  }

    /* Quill Editor Overrides */
  ::v-deep(.ql-container) {
    font-family: "GatterSans" !important;
    font-size: 16px !important;
    border-bottom-left-radius: var(--radius-md);
    border-bottom-right-radius: var(--radius-md);
  }

  ::v-deep(.ql-toolbar) {
    border: 1px solid var(--light-gray) !important;
    border-top-left-radius: var(--radius-md);
    border-top-right-radius: var(--radius-md);
    background-color: var(--almost-white);
  }

  ::v-deep(.ql-editor) {
    border: 1px solid var(--light-gray) !important;
    border-top: 0px;
    min-height: 200px;
  }

  </style>
  